"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _Progress = require("../components/Progress");
var _ConfirmDialog = require("../ConfirmDialog");
var _ModalErrors = require("./ModalErrors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ModalContent = exports.ModalContent = function ModalContent(_ref) {
  var profile = _ref.profile,
    transitioning = _ref.transitioning,
    stepName = _ref.stepName,
    CurrentStep = _ref.CurrentStep,
    responseError = _ref.responseError;
  // XXX: Use reducer
  var name = profile.name;
  if (transitioning) {
    return /*#__PURE__*/_react.default.createElement(_Progress.Progress, null);
  }
  if (stepName === "confirm") {
    return /*#__PURE__*/_react.default.createElement(_ConfirmDialog.ConfirmDialog, {
      name: name
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ModalErrors.ModalErrors, {
    responseError: responseError
  }), CurrentStep);
};